export const REVIEWORDERS: any = {
    'Increase': {
        // quantity1: 'You currently have {x} licenses at ${y} per month.',
        quantity1: 'Number of Licenses {x}  @ ${y}/user',
        quantity2: 'Additional {x} licenses ',
        quantity3: 'Total monthly charges for {x} licenses.',
        // tslint:disable-next-line:max-line-length
        content: '*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.'
    },
    'Decrease': {
        quantity1: 'You currently have {x} licenses @ ${y} per month.',
        quantity2: 'Remove {x} licenses ',
        quantity3: 'Total monthly charges for {x} licenses',
        // tslint:disable-next-line:max-line-length
        content: '*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.'
    },
    'RemoveAll': {
        quantity1: 'You currently have {x} {licenses}.',
        quantity2: 'You\'re removing {x} {licenses} and un-assigning {y} users',
        quantity3: 'Total monthly charges',
        // tslint:disable-next-line:max-line-length
        content: '*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.',
        reviewTitle: 'Cancel a product',
        confirmTitle: 'Confirm canceling a product',
        submitCaption: 'Submit order'
    },
    'DiffCTN': {
        quantity1: ' {x} licenses @ ${y} per month ',
        quantity2: '',
        quantity3: 'Total monthly charges',
        // tslint:disable-next-line:max-line-length
        content: '*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.'
    },
    'changeProduct': {
        quantity1: '<strong>Current product:</strong> <br>{cp} <br>{x} licenses @ ${y} per month.',
        quantity2: '<strong>New product:</strong> <br>{np} <br>{x} licenses @ ${y} per month.',
        quantity3: 'Total monthly charges',
        // tslint:disable-next-line:max-line-length
        content: '*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.'
    }

};


